import { useState } from "react";
import Rating from "../base/Rating";
import { ProviderCard as ProductType } from "../../data/ecommerce/providers";
import { Link } from "react-router-dom";
import LocationTag from "../base/Tags/LocationTag";
import CategoryTag from "../base/Tags/CategoryTag";
import VerifiedBadge from "../base/Tags/VerifiedBadge";
import defaultProviderImage from "../../assets/img/providers/default.jpg";

const ProductCard = ({ product }: { product: ProductType }) => {
  const additionalCategories = (product.Category || []).length - 1; // Number of extra categories
  const additionalLocations = (product.Location || []).length - 1; // Number of extra locations

  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="position-relative  product-card h-100">
      <div className="d-flex flex-column justify-content-between h-10">
        <Link
          to={`/home/store/${product.uniqueName}`}
          className="stretched-link text-decoration-none"
        >
          <div className="position-relative mb-3 img-border">
            {!isLoaded && (
              <img
                src={defaultProviderImage}
                alt="placeholder"
                className="provider-image position-absolute top-0 start-0 w-100 h-100"
                style={{ objectFit: "cover", zIndex: 1 }}
              />
            )}
            <img
              src={product.image}
              alt={product.name}
              loading="lazy"
              className="provider-image w-100 h-100"
              style={{
                objectFit: "cover",
                opacity: isLoaded ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
                position: "relative",
                zIndex: 2,
              }}
              onLoad={() => setIsLoaded(true)}
              onError={(e) => {
                if (e.currentTarget.src !== defaultProviderImage) {
                  e.currentTarget.src = defaultProviderImage;
                } else {
                  setIsLoaded(true);
                }
              }}
            />

            {product.verified && <VerifiedBadge />}
          </div>
          <div className=" provider-name fw-medium fs-7 mb-2 lh-sm line-clamp-1 ">
            {product.name}
          </div>
          {/* Categories row */}
          <div className="d-flex gap-2 pb-2 text-decoration-none">
            {product.Category && product.Category.length > 0 && (
              <>
                <CategoryTag category={product.Category[0]} />
                {additionalCategories > 0 && (
                  <span className="text-secondary fs-9">
                    +{additionalCategories}
                  </span>
                )}
              </>
            )}
          </div>

          {/* Locations row */}
          <div className="d-flex gap-2 pb-2 text-decoration-none">
            {product.Location && product.Location.length > 0 && (
              <>
                <LocationTag city={product.Location[0]} />
                {additionalLocations > 0 && (
                  <span className="text-secondary fs-9">
                    +{additionalLocations}
                  </span>
                )}
              </>
            )}
          </div>
        </Link>

        <p className="fs-9 mb-2">
          <Rating readonly initialValue={product.rating} onChange={() => {}} />
          <span className="text-500 fw-semi-bold ms-1 ">({product.rated})</span>
        </p>

        <div
          className="grey-separator"
          style={{
            height: "3px",
            backgroundColor: "#E3E6ED",
            width: "100%",
          }}
        />
        {/* sub categories (green tags) */}
        {/* <div className="line-clamp-1">
          {product.SubCategory && // TO-DO:  will have to limit these tags to 1 lines, any left will have a +n where n is number of tags that werent shown.
            product.SubCategory.map((subCategory, index) => (
              <SubCategoryTag key={index} category={subCategory} />
            ))}
        </div> */}
      </div>
    </div>
  );
};
export default ProductCard;
